import React from 'react';
import { Download, Mail, Search } from 'lucide-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import './styles.css';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

const FilterBar = ({ filters, onFilterChange, onDownload, loading }) => {
  return (
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '15px',
        marginBottom: '20px'
      }}>
        {/* Data Inicial */}
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>
            Data Inicial
          </label>
          <DatePicker
            selected={filters.startDate}
            onChange={(date) => onFilterChange({ ...filters, startDate: date })}
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            placeholderText="Selecione a data inicial"
            maxDate={filters.endDate || new Date()}
            className="datepicker-input"
            customInput={
              <input style={{
                width: '90%',
                padding: '8px 12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '0.9rem'
              }} />
            }
          />
        </div>

        {/* Data Final */}
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>
            Data Final
          </label>
          <DatePicker
            selected={filters.endDate}
            onChange={(date) => onFilterChange({ ...filters, endDate: date })}
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            placeholderText="Selecione a data final"
            minDate={filters.startDate}
            maxDate={new Date()}
            className="datepicker-input"
            customInput={
              <input style={{
                width: '90%',
                padding: '8px 12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '0.9rem'
              }} />
            }
          />
        </div>

        {/* Número do Pedido */}
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem' }}>
            Número do Pedido
          </label>
          <div style={{ position: 'relative' }}>
            <Search size={18} style={{
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#666',
              zIndex: 1
            }} />
            <input
              type="text"
              value={filters.orderNumber}
              onChange={(e) => onFilterChange({ ...filters, orderNumber: e.target.value })}
              placeholder="Buscar por número..."
              style={{
                width: '90%',
                padding: '8px 12px 8px 35px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
      </div>

      {/* Botões de ação */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px'
      }}>
        <button
        onClick={onDownload}
          disabled={loading || (!filters.orderNumber && (!filters.startDate || !filters.endDate))}
          style={{
            padding: '8px 16px',
            backgroundColor: '#2D3277',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            opacity: loading ? 0.7 : 1
          }}
        >
          <Download size={18} />
          <span>Baixar</span> 
         {/*  onClick={() => {
            console.log('Clicou em baixar');  // Debug
            onDownload();
          }} */}
        </button>

        <button
          disabled={loading || (!filters.orderNumber && (!filters.startDate || !filters.endDate))}
          style={{
            padding: '8px 16px',
            backgroundColor: '#2D3277',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            opacity: loading ? 0.7 : 1
          }}
        >
          <Mail size={18} />
          Enviar por Email
        </button>
      </div>
    </div>
  );
};

export default FilterBar;